/* eslint-disable no-underscore-dangle */
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useCallback } from 'react';
import { useClearRefinements, useRefinementList } from 'react-instantsearch';

import { FilterSection } from '@sorare/core/src/components/search/FilterSection';
import { Option } from '@sorare/core/src/components/search/Option';
import { sortHitByRarity } from '@sorare/core/src/lib/cards';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { FILTERS, FilterWidget } from '@sorare/core/src/lib/filters';
import { formatWord } from '@sorare/core/src/lib/humanize';

const FILTER = FILTERS.rarity;

const RadioRarityFilter = ({ visible }: { visible: boolean }) => {
  const { refine: clearRefinements } = useClearRefinements({
    // this is required to also clear the query string
    includedAttributes: [FILTER.attribute],
  });
  const { items, refine: doRefine } = useRefinementList({
    attribute: FILTER.attribute,
    limit: 10,
    transformItems: sortHitByRarity,
  });

  const track = useEvents();

  const onChange = useCallback(
    (rarity: RefinementListItem) => {
      clearRefinements();
      track('Use Market Filter', {
        filterName: FILTER.attribute,
        filterValue: rarity.value,
      });

      doRefine(rarity.value);
    },
    [clearRefinements, doRefine, track]
  );

  if (!visible) return <FilterSection />;

  return (
    <FilterSection>
      {items.map(item => (
        <div className="option-wrapper" key={item.label}>
          <Option
            label={formatWord(item.label)}
            active={item.isRefined}
            onClick={() => {
              onChange(item);
            }}
            variant="radio"
          />
        </div>
      ))}
    </FilterSection>
  );
};

const widget: FilterWidget = {
  key: FILTER.attribute,
  type: 'list',
  attribute: FILTER.attribute,
  Component: RadioRarityFilter,
  title: null,
  accordionOptions: { startsOpen: true },
};

export default widget;
